<template>
  <PmDialogConfirmPure
    title="Urlaubsantrag Stornierung beantragen?"
    action-label="Stornierung beantragen"
    :is-loading="isLoading"
    :error-message="errorMessage"
    :error-details="errorDetails"
    :form-id="formId"
    @cancel="emit('cancel')"
  >
    <div :class="componentClass.root">
      <PmFormPure :id="formId" :disabled="isLoading" @submit.prevent="onSubmit">
        <PmTextareaPure
          v-model:value="note"
          label="Bemerkung"
          :rows="3"
          :required="true"
        />
      </PmFormPure>
    </div>
  </PmDialogConfirmPure>
</template>

<script setup lang="ts">
import { useComponentClass } from '@thomasaull-shared/composables'
import { ref } from 'vue'
import cuid from '@paralleldrive/cuid2'
import PmDialogConfirmPure from '@/components/basics/PmDialog/PmDialogConfirmPure.vue'
import PmFormPure from '@/components/basics/PmForm/PmFormPure.vue'
import PmTextareaPure from '@/components/basics/PmTextarea/PmTextareaPure.vue'

export interface Props {
  isLoading?: boolean
  errorMessage?: string
  errorDetails?: string[]
}

const props = withDefaults(defineProps<Props>(), {})

export type Emits = {
  cancel: []
  submit: [
    payload: {
      note: string
    },
  ]
}

const emit = defineEmits<Emits>()

const componentClass = useComponentClass({ props })
const formId = cuid.createId()
const note = ref<string>()

function onSubmit() {
  if (!note.value) throw new Error('note is undefined')

  emit('submit', {
    note: note.value,
  })
}
</script>
